function Loading() {
  return (
    <>
      <section className="loadingSection">
        <div className="loadingInnerContainer">
          <p className="loadingP">Loading...</p>

          <div className="sp dot-flashing"></div>
        </div>
      </section>
    </>
  );
}

export default Loading;
